import { render, staticRenderFns } from "./CommunityProfile.vue?vue&type=template&id=402f1e78&scoped=true&"
import script from "./CommunityProfile.vue?vue&type=script&lang=js&"
export * from "./CommunityProfile.vue?vue&type=script&lang=js&"
import style0 from "./CommunityProfile.vue?vue&type=style&index=0&id=402f1e78&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "402f1e78",
  null
  
)

export default component.exports